/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type BenefitsChartHeader_tradeFirm$ref: FragmentReference;
export type BenefitsChartHeader_tradeFirm = {|
  +rewards: ?{|
    +currentProgram: ?{|
      +programInfo: ?{|
        +code: ?string
      |}
    |}
  |},
  +$refType: BenefitsChartHeader_tradeFirm$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "BenefitsChartHeader_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "rewards",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmRewards",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "currentProgram",
          "storageKey": null,
          "args": null,
          "concreteType": "ParentProgram",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "programInfo",
              "storageKey": null,
              "args": null,
              "concreteType": "LoyaltyProgram",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "code",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '5a3947bad5127271b9a37ae749d712b9';
module.exports = node;
